import React from 'react';
import { Link } from 'react-router-dom';
import { Brain, Mail, Phone, ShieldCheck, MapPin, Heart } from 'lucide-react';
import { siteConfig } from '../data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-blue-950 text-slate-300 overflow-hidden border-t border-white/10">
      {/* Upper Footer */}
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3 group">
              {siteConfig.images.logo ? (
                <img
                  src={siteConfig.images.logo}
                  alt="SECoaching Logo"
                  className="h-24 w-auto object-contain"
                />
              ) : (
                <div>
                  <span className="text-3xl font-extrabold tracking-tight text-white transition-colors">
                    SE<span className="text-sky-400">Coaching</span>
                  </span>
                  <span className="block text-[11px] uppercase tracking-widest text-slate-400 font-semibold mt-0.5">
                    Mindset & Udvikling
                  </span>
                </div>
              )}
            </Link>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white">Hurtige links</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="hover:text-sky-400 transition-colors">Forside</Link>
              </li>
              <li>
                <Link to="/forloeb-og-priser" className="hover:text-sky-400 transition-colors">Forløb og priser</Link>
              </li>
              <li>
                <Link to="/mindsetforloeb" className="hover:text-sky-400 transition-colors">Mindsetforløb</Link>
              </li>
              <li>
                <Link to="/om-mig" className="hover:text-sky-400 transition-colors">Om mig</Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-sky-400 transition-colors">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white">Kontakt Steffen</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-white shrink-0 mt-0.5" />
                <div>
                  <a href={`mailto:${siteConfig.email}`} className="hover:text-sky-400 transition-colors font-medium">
                    {siteConfig.email}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-white shrink-0 mt-0.5" />
                <div>
                  <a href={`tel:${siteConfig.phone}`} className="hover:text-sky-400 transition-colors font-medium">
                    {siteConfig.phoneFormatted}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-white shrink-0 mt-0.5" />
                <div>
                  <span className="font-medium text-slate-300">
                    Personlige samtaler (online eller fysisk efter aftale)
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="py-8 text-center text-xs text-slate-500 relative z-10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p>© {currentYear} SECoaching. Alle rettigheder forbeholdes. · CVR: {siteConfig.cvr}</p>
        </div>
      </div>
    </footer>
  );
}
